/** Bump when a cached response gains an authoritative field, so older caches are discarded. */
export const QUERY_CACHE_SCHEMA_VERSION = 2;

/** Discards the persisted cache on a change of user or of cache schema. */
export const persistedQueryCacheBuster = (uid: string | undefined) =>
  `${uid ?? 'logged-out'}:${QUERY_CACHE_SCHEMA_VERSION}`;
